export const YEAR_1_KEY = 1;
export const YEAR_2_KEY = 2;
export const YEAR_3_KEY = 3;
export const YEAR_4_KEY = 4;
export const YEAR_5_KEY = 5;

export const years = {
  YEAR_1_KEY,
  YEAR_2_KEY,
  YEAR_3_KEY,
  YEAR_4_KEY,
  YEAR_5_KEY,
};
